// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "mlinference/internalapi/v1/mlinference.proto" (package "mlinference.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private ml inference annotations RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Status } from "../../../google/rpc/status";
import { ModelType } from "../../../app/mltraining/v1/ml_training";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message mlinference.internalapi.v1.StartInferenceJobRequest
 */
export interface StartInferenceJobRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string registry_id = 2;
     */
    registryId: string;
    /**
     * @generated from protobuf field: string registry_version = 3;
     */
    registryVersion: string;
    /**
     * @generated from protobuf field: float confidence_threshold = 4;
     */
    confidenceThreshold: number;
    /**
     * @generated from protobuf field: string organization_id = 5;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.StartInferenceJobResponse
 */
export interface StartInferenceJobResponse {
    /**
     * @generated from protobuf field: string inference_job_id = 1;
     */
    inferenceJobId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.GetInferenceJobRequest
 */
export interface GetInferenceJobRequest {
    /**
     * @generated from protobuf field: string inference_job_id = 1;
     */
    inferenceJobId: string;
    /**
     * @generated from protobuf field: bool include_binary_data_in_review_count = 2;
     */
    includeBinaryDataInReviewCount: boolean;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.GetInferenceJobResponse
 */
export interface GetInferenceJobResponse {
    /**
     * @generated from protobuf field: mlinference.internalapi.v1.InferenceJob inference_job = 1;
     */
    inferenceJob?: InferenceJob;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.InferenceJob
 */
export interface InferenceJob {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string dataset_id = 2;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string registry_item_id = 3;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_version = 4;
     */
    registryVersion: string;
    /**
     * @generated from protobuf field: float confidence_threshold = 5;
     */
    confidenceThreshold: number;
    /**
     * @generated from protobuf field: string organization_id = 6;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: mlinference.internalapi.v1.InferenceJobStatus status = 7;
     */
    status: InferenceJobStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 8;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_modified = 9;
     */
    lastModified?: Timestamp;
    /**
     * Only returned in GetInferenceJob endpoint, when include_count_binary_data_in_review is true
     *
     * @generated from protobuf field: optional int32 binary_data_in_review_count = 10;
     */
    binaryDataInReviewCount?: number;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.ListInferenceJobsRequest
 */
export interface ListInferenceJobsRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: mlinference.internalapi.v1.InferenceJobStatus status = 7;
     */
    status: InferenceJobStatus;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.ListInferenceJobsResponse
 */
export interface ListInferenceJobsResponse {
    /**
     * @generated from protobuf field: repeated mlinference.internalapi.v1.InferenceJob inference_jobs = 1;
     */
    inferenceJobs: InferenceJob[];
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.DismissJobRequest
 */
export interface DismissJobRequest {
    /**
     * @generated from protobuf field: string inference_job_id = 1;
     */
    inferenceJobId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.DismissJobResponse
 */
export interface DismissJobResponse {
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.StartEvaluationJobRequest
 */
export interface StartEvaluationJobRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string registry_id = 2;
     */
    registryId: string;
    /**
     * @generated from protobuf field: string registry_version = 3;
     */
    registryVersion: string;
    /**
     * @generated from protobuf field: float confidence_threshold = 4;
     */
    confidenceThreshold: number;
    /**
     * @generated from protobuf field: string organization_id = 5;
     */
    organizationId: string;
    /**
     * Only used for object detection models. Minimum bounding box overlap
     * required for a prediction to count as a true positive.
     *
     * @generated from protobuf field: float iou_threshold = 6;
     */
    iouThreshold: number;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.StartEvaluationJobResponse
 */
export interface StartEvaluationJobResponse {
    /**
     * @generated from protobuf field: string evaluation_job_id = 1;
     */
    evaluationJobId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.GetEvaluationJobRequest
 */
export interface GetEvaluationJobRequest {
    /**
     * @generated from protobuf field: string evaluation_job_id = 1;
     */
    evaluationJobId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.GetEvaluationJobResponse
 */
export interface GetEvaluationJobResponse {
    /**
     * @generated from protobuf field: mlinference.internalapi.v1.EvaluationJob evaluation_job = 1;
     */
    evaluationJob?: EvaluationJob;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.ListEvaluationJobsRequest
 */
export interface ListEvaluationJobsRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.ListEvaluationJobsResponse
 */
export interface ListEvaluationJobsResponse {
    /**
     * @generated from protobuf field: repeated mlinference.internalapi.v1.EvaluationJob evaluation_jobs = 1;
     */
    evaluationJobs: EvaluationJob[];
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.CancelEvaluationJobRequest
 */
export interface CancelEvaluationJobRequest {
    /**
     * @generated from protobuf field: string evaluation_job_id = 1;
     */
    evaluationJobId: string;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.CancelEvaluationJobResponse
 */
export interface CancelEvaluationJobResponse {
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.ClassMetrics
 */
export interface ClassMetrics {
    /**
     * @generated from protobuf field: string label = 1;
     */
    label: string;
    /**
     * @generated from protobuf field: int32 label_count = 2;
     */
    labelCount: number;
    /**
     * @generated from protobuf field: float precision = 3;
     */
    precision: number;
    /**
     * @generated from protobuf field: float recall = 4;
     */
    recall: number;
    /**
     * @generated from protobuf field: float f1 = 5;
     */
    f1: number;
}
/**
 * @generated from protobuf message mlinference.internalapi.v1.EvaluationJob
 */
export interface EvaluationJob {
    /**
     * Job identity
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string dataset_id = 2;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string organization_id = 3;
     */
    organizationId: string;
    /**
     * Model
     *
     * @generated from protobuf field: string registry_item_id = 4;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_version = 5;
     */
    registryVersion: string;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 6;
     */
    modelType: ModelType;
    /**
     * Job configuration
     *
     * @generated from protobuf field: float confidence_threshold = 7;
     */
    confidenceThreshold: number;
    /**
     * Only set for object detection models.
     *
     * @generated from protobuf field: float iou_threshold = 8;
     */
    iouThreshold: number;
    /**
     * Job lifecycle
     *
     * @generated from protobuf field: mlinference.internalapi.v1.EvaluationJobStatus status = 9;
     */
    status: EvaluationJobStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 10;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_modified = 11;
     */
    lastModified?: Timestamp;
    /**
     * Set when status is FAILED. Empty otherwise.
     *
     * @generated from protobuf field: google.rpc.Status error_status = 12;
     */
    errorStatus?: Status;
    /**
     * Progress
     * Total images paged through in the dataset, including ones not evaluated.
     *
     * @generated from protobuf field: int32 images_processed = 13;
     */
    imagesProcessed: number;
    /**
     * Images that contributed to the metrics. Datasets are assumed fully labeled,
     * so an image with no ground truth is a negative for every model class and is
     * still evaluated. Only images whose labels fall entirely outside the model's
     * output classes are excluded.
     *
     * @generated from protobuf field: int32 images_evaluated = 14;
     */
    imagesEvaluated: number;
    /**
     * Aggregate results. Only set when status is COMPLETED.
     * Macro average across all classes in the intersection: each class's own
     * precision/recall/f1 is averaged unweighted, so rare classes count equally.
     *
     * @generated from protobuf field: float precision = 15;
     */
    precision: number;
    /**
     * @generated from protobuf field: float recall = 16;
     */
    recall: number;
    /**
     * @generated from protobuf field: float f1 = 17;
     */
    f1: number;
    /**
     * Detailed results.
     * Metrics for all classes in the intersection of the model's output classes
     * and the dataset's labels, sorted by label_count descending.
     *
     * @generated from protobuf field: repeated mlinference.internalapi.v1.ClassMetrics class_metrics = 18;
     */
    classMetrics: ClassMetrics[];
    /**
     * Model output classes for which the dataset had no matching ground-truth
     * labels. These classes were not evaluated and are excluded from all metrics.
     *
     * @generated from protobuf field: repeated string unevaluated_model_classes = 19;
     */
    unevaluatedModelClasses: string[];
}
/**
 * @generated from protobuf enum mlinference.internalapi.v1.InferenceJobStatus
 */
export enum InferenceJobStatus {
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_PROVISIONING = 1;
     */
    PROVISIONING = 1,
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_IN_PROGRESS = 2;
     */
    IN_PROGRESS = 2,
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_FAILED = 3;
     */
    FAILED = 3,
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_COMPLETED = 4;
     */
    COMPLETED = 4,
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_ANNOTATIONS_REVIEW_IN_PROGRESS = 5;
     */
    ANNOTATIONS_REVIEW_IN_PROGRESS = 5,
    /**
     * @generated from protobuf enum value: INFERENCE_JOB_STATUS_ANNOTATIONS_REVIEW_COMPLETED = 6;
     */
    ANNOTATIONS_REVIEW_COMPLETED = 6
}
/**
 * @generated from protobuf enum mlinference.internalapi.v1.EvaluationJobStatus
 */
export enum EvaluationJobStatus {
    /**
     * @generated from protobuf enum value: EVALUATION_JOB_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EVALUATION_JOB_STATUS_PROVISIONING = 1;
     */
    PROVISIONING = 1,
    /**
     * @generated from protobuf enum value: EVALUATION_JOB_STATUS_IN_PROGRESS = 2;
     */
    IN_PROGRESS = 2,
    /**
     * @generated from protobuf enum value: EVALUATION_JOB_STATUS_FAILED = 3;
     */
    FAILED = 3,
    /**
     * @generated from protobuf enum value: EVALUATION_JOB_STATUS_COMPLETED = 4;
     */
    COMPLETED = 4,
    /**
     * @generated from protobuf enum value: EVALUATION_JOB_STATUS_CANCELLED = 5;
     */
    CANCELLED = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class StartInferenceJobRequest$Type extends MessageType<StartInferenceJobRequest> {
    constructor() {
        super("mlinference.internalapi.v1.StartInferenceJobRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "registry_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "confidence_threshold", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.StartInferenceJobRequest
 */
export const StartInferenceJobRequest = new StartInferenceJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartInferenceJobResponse$Type extends MessageType<StartInferenceJobResponse> {
    constructor() {
        super("mlinference.internalapi.v1.StartInferenceJobResponse", [
            { no: 1, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.StartInferenceJobResponse
 */
export const StartInferenceJobResponse = new StartInferenceJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInferenceJobRequest$Type extends MessageType<GetInferenceJobRequest> {
    constructor() {
        super("mlinference.internalapi.v1.GetInferenceJobRequest", [
            { no: 1, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_binary_data_in_review_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.GetInferenceJobRequest
 */
export const GetInferenceJobRequest = new GetInferenceJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInferenceJobResponse$Type extends MessageType<GetInferenceJobResponse> {
    constructor() {
        super("mlinference.internalapi.v1.GetInferenceJobResponse", [
            { no: 1, name: "inference_job", kind: "message", T: () => InferenceJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.GetInferenceJobResponse
 */
export const GetInferenceJobResponse = new GetInferenceJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferenceJob$Type extends MessageType<InferenceJob> {
    constructor() {
        super("mlinference.internalapi.v1.InferenceJob", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "registry_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "confidence_threshold", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status", kind: "enum", T: () => ["mlinference.internalapi.v1.InferenceJobStatus", InferenceJobStatus, "INFERENCE_JOB_STATUS_"] },
            { no: 8, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 9, name: "last_modified", kind: "message", T: () => Timestamp },
            { no: 10, name: "binary_data_in_review_count", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.InferenceJob
 */
export const InferenceJob = new InferenceJob$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListInferenceJobsRequest$Type extends MessageType<ListInferenceJobsRequest> {
    constructor() {
        super("mlinference.internalapi.v1.ListInferenceJobsRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status", kind: "enum", T: () => ["mlinference.internalapi.v1.InferenceJobStatus", InferenceJobStatus, "INFERENCE_JOB_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.ListInferenceJobsRequest
 */
export const ListInferenceJobsRequest = new ListInferenceJobsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListInferenceJobsResponse$Type extends MessageType<ListInferenceJobsResponse> {
    constructor() {
        super("mlinference.internalapi.v1.ListInferenceJobsResponse", [
            { no: 1, name: "inference_jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InferenceJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.ListInferenceJobsResponse
 */
export const ListInferenceJobsResponse = new ListInferenceJobsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DismissJobRequest$Type extends MessageType<DismissJobRequest> {
    constructor() {
        super("mlinference.internalapi.v1.DismissJobRequest", [
            { no: 1, name: "inference_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.DismissJobRequest
 */
export const DismissJobRequest = new DismissJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DismissJobResponse$Type extends MessageType<DismissJobResponse> {
    constructor() {
        super("mlinference.internalapi.v1.DismissJobResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.DismissJobResponse
 */
export const DismissJobResponse = new DismissJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartEvaluationJobRequest$Type extends MessageType<StartEvaluationJobRequest> {
    constructor() {
        super("mlinference.internalapi.v1.StartEvaluationJobRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "registry_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "confidence_threshold", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "iou_threshold", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.StartEvaluationJobRequest
 */
export const StartEvaluationJobRequest = new StartEvaluationJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartEvaluationJobResponse$Type extends MessageType<StartEvaluationJobResponse> {
    constructor() {
        super("mlinference.internalapi.v1.StartEvaluationJobResponse", [
            { no: 1, name: "evaluation_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.StartEvaluationJobResponse
 */
export const StartEvaluationJobResponse = new StartEvaluationJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEvaluationJobRequest$Type extends MessageType<GetEvaluationJobRequest> {
    constructor() {
        super("mlinference.internalapi.v1.GetEvaluationJobRequest", [
            { no: 1, name: "evaluation_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.GetEvaluationJobRequest
 */
export const GetEvaluationJobRequest = new GetEvaluationJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEvaluationJobResponse$Type extends MessageType<GetEvaluationJobResponse> {
    constructor() {
        super("mlinference.internalapi.v1.GetEvaluationJobResponse", [
            { no: 1, name: "evaluation_job", kind: "message", T: () => EvaluationJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.GetEvaluationJobResponse
 */
export const GetEvaluationJobResponse = new GetEvaluationJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEvaluationJobsRequest$Type extends MessageType<ListEvaluationJobsRequest> {
    constructor() {
        super("mlinference.internalapi.v1.ListEvaluationJobsRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.ListEvaluationJobsRequest
 */
export const ListEvaluationJobsRequest = new ListEvaluationJobsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEvaluationJobsResponse$Type extends MessageType<ListEvaluationJobsResponse> {
    constructor() {
        super("mlinference.internalapi.v1.ListEvaluationJobsResponse", [
            { no: 1, name: "evaluation_jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EvaluationJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.ListEvaluationJobsResponse
 */
export const ListEvaluationJobsResponse = new ListEvaluationJobsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelEvaluationJobRequest$Type extends MessageType<CancelEvaluationJobRequest> {
    constructor() {
        super("mlinference.internalapi.v1.CancelEvaluationJobRequest", [
            { no: 1, name: "evaluation_job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.CancelEvaluationJobRequest
 */
export const CancelEvaluationJobRequest = new CancelEvaluationJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelEvaluationJobResponse$Type extends MessageType<CancelEvaluationJobResponse> {
    constructor() {
        super("mlinference.internalapi.v1.CancelEvaluationJobResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.CancelEvaluationJobResponse
 */
export const CancelEvaluationJobResponse = new CancelEvaluationJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClassMetrics$Type extends MessageType<ClassMetrics> {
    constructor() {
        super("mlinference.internalapi.v1.ClassMetrics", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "precision", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "recall", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "f1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.ClassMetrics
 */
export const ClassMetrics = new ClassMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EvaluationJob$Type extends MessageType<EvaluationJob> {
    constructor() {
        super("mlinference.internalapi.v1.EvaluationJob", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "registry_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"] },
            { no: 7, name: "confidence_threshold", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "iou_threshold", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "status", kind: "enum", T: () => ["mlinference.internalapi.v1.EvaluationJobStatus", EvaluationJobStatus, "EVALUATION_JOB_STATUS_"] },
            { no: 10, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 11, name: "last_modified", kind: "message", T: () => Timestamp },
            { no: 12, name: "error_status", kind: "message", T: () => Status },
            { no: 13, name: "images_processed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "images_evaluated", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "precision", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 16, name: "recall", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 17, name: "f1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 18, name: "class_metrics", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ClassMetrics },
            { no: 19, name: "unevaluated_model_classes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mlinference.internalapi.v1.EvaluationJob
 */
export const EvaluationJob = new EvaluationJob$Type();
/**
 * @generated ServiceType for protobuf service mlinference.internalapi.v1.InternalMLInferenceService
 */
export const InternalMLInferenceService = new ServiceType("mlinference.internalapi.v1.InternalMLInferenceService", [
    { name: "StartInferenceJob", options: {}, I: StartInferenceJobRequest, O: StartInferenceJobResponse },
    { name: "GetInferenceJob", options: {}, I: GetInferenceJobRequest, O: GetInferenceJobResponse },
    { name: "ListInferenceJobs", options: {}, I: ListInferenceJobsRequest, O: ListInferenceJobsResponse },
    { name: "DismissJob", options: {}, I: DismissJobRequest, O: DismissJobResponse },
    { name: "StartEvaluationJob", options: {}, I: StartEvaluationJobRequest, O: StartEvaluationJobResponse },
    { name: "GetEvaluationJob", options: {}, I: GetEvaluationJobRequest, O: GetEvaluationJobResponse },
    { name: "ListEvaluationJobs", options: {}, I: ListEvaluationJobsRequest, O: ListEvaluationJobsResponse },
    { name: "CancelEvaluationJob", options: {}, I: CancelEvaluationJobRequest, O: CancelEvaluationJobResponse }
]);
